exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fm-thumbnail {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.fm-thumbnail .img-thumbnail {\n  width: 88px;\n  height: 88px;\n}\n.fm-thumbnail .fade-enter-active, .fm-thumbnail .fade-leave-active {\n  transition: opacity 0.3s;\n}\n.fm-thumbnail .fade-enter, .fm-thumbnail .fade-leave-to {\n  opacity: 0;\n}", ""]);

// exports
